import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams } from 'react-router-dom';

import FileDetailWhatsapp from 'components/Tvendo/Reports/File/FileDetails/list.js';
import FileNumberWhatsapp from 'components/Tvendo/Reports/File/FileNumbers/list.js';
import FileHourWhatsapp from 'components/Tvendo/Reports/File/FileHours/list.js';
import FileDayWhatsapp from 'components/Tvendo/Reports/File/FileDays/list.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsGet } from 'services/WService';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();

  const themeTab = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [fileReports, setFileReports] = useState({});
  const [fDRDetails, setFDRDetails] = useState([]);
  const [fNReport, setFNReport] = useState([]);
  const [fHReport, setFHReport] = useState([]);
  const [fDReport, setFDReport] = useState([]);

  async function getFileReport() {
    let response = await wsGet('report/file-report', id);
    if (response.success) {
      setFileReports(response.data);
    }
  }
  async function getFileDetailReport() {
    let response = await wsFindBy('report/file-detail-report', { file_report_id: fileReports.id });
    if (response.success) setFDRDetails(response.data);
  }
  async function getFileNumberReport() {
    let response = await wsFindBy('report/file-number-report', { file_report_id: fileReports.id });
    if (response.success) setFNReport(response.data);
  }
  async function getFileHourReport() {
    let response = await wsFindBy('report/file-hour-report', { file_report_id: fileReports.id });
    if (response.success) setFHReport(response.data);
  }
  async function getFileDayReport() {
    let response = await wsFindBy('report/file-day-report', { file_report_id: fileReports.id });
    if (response.success) setFDReport(response.data);
  }

  useEffect(() => {
    getFileReport();
  }, []);

  useEffect(()=> {
    if(fileReports.id){
      getFileNumberReport();
      getFileHourReport();
      getFileDayReport();
    }
  },[fileReports.id]);

  useEffect(()=> {
    if(fileReports.type === 'xlsx'){
      getFileDetailReport();
    }
  },[fileReports.type]);

  let tabs = [
    <Tab label="Detalle" {...indexTab(0)} />,
    <Tab label="Contactos" {...indexTab(1)} />,
    <Tab label="Horas" {...indexTab(2)} />,
    <Tab label="Dias" {...indexTab(3)} />
  ];
  if (fileReports.type !== 'xlsx') {
    tabs = [
      <Tab label="Contactos" {...indexTab(0)} />,
      <Tab label="Horas" {...indexTab(1)} />,
      <Tab label="Dias" {...indexTab(2)} />
    ];
  }

  let tabPanels = [
    <TabPanel value={value} index={0} dir={themeTab.direction}>
      <FileDetailWhatsapp
        id={id}
        showNotify={showNotify}
        confirm={confirm}
        fDRDetails={fDRDetails}
        Contact={fNReport}
        fileReports={fileReports}
        reload={getFileDetailReport}
      />
    </TabPanel>,
    <TabPanel value={value} index={1} dir={themeTab.direction}>
      <FileNumberWhatsapp
        id={id}
        showNotify={showNotify}
        confirm={confirm}
        fNReport={fNReport}
        setFNReport={setFNReport}
        fileReports={fileReports}
        reload={getFileNumberReport}
      />
    </TabPanel>,
    <TabPanel value={value} index={2} dir={themeTab.direction}>
      <FileHourWhatsapp
        id={id}
        showNotify={showNotify}
        confirm={confirm}
        fHReport={fHReport}
        setFHReport={setFHReport}
        fileReports={fileReports}
        reload={getFileHourReport}
      />
    </TabPanel>,
    <TabPanel value={value} index={3} dir={themeTab.direction}>
      <FileDayWhatsapp
        id={id}
        showNotify={showNotify}
        confirm={confirm}
        fDReport={fDReport}
        setFDReport={setFDReport}
        fileReports={fileReports}
        reload={getFileDayReport}
      />
    </TabPanel>,
  ];
  if (fileReports.type !== 'xlsx') {
    tabPanels = [
      <TabPanel value={value} index={0} dir={themeTab.direction}>
        <FileNumberWhatsapp
          id={id}
          showNotify={showNotify}
          confirm={confirm}
          fNReport={fNReport}
          setFNReport={setFNReport}
          fileReports={fileReports}
          reload={getFileNumberReport}
        />
      </TabPanel>,
      <TabPanel value={value} index={1} dir={themeTab.direction}>
        <FileHourWhatsapp
          id={id}
          showNotify={showNotify}
          confirm={confirm}
          fHReport={fHReport}
          setFHReport={setFHReport}
          fileReports={fileReports}
          reload={getFileHourReport}
        />
      </TabPanel>,
      <TabPanel value={value} index={2} dir={themeTab.direction}>
        <FileDayWhatsapp
          id={id}
          showNotify={showNotify}
          confirm={confirm}
          fDReport={fDReport}
          setFDReport={setFDReport}
          fileReports={fileReports}
          reload={getFileDayReport}
        />
      </TabPanel>,
    ];
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>Archivo: {fileReports.file_name} - {fileReports.activity?.description}</h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                {tabs}
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              {tabPanels}
            </SwipeableViews>
          </div>
        </Fragment>
      ) : undefined}
    </Fragment>
  );
}
